import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { AsyncPipe, NgIf } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { Observable, combineLatest, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ActionItem, ActionItemStyle } from '../../../../elements/components/action-item/entities/action-item.entity';
import { FormRadioListItem } from '../../../entities/form-radio-list-item.entity';
import { FormValue, FormValueState } from '../../../entities/form-value.entity';
import { ShBaseFormComponent } from '../../_core/base-form/base-form.component';
import { ShFormGroupComponent } from '../../_core/form-group/form-group.component';
import { ShFormRadioListComplexBaseComponent } from '../base-complex/form-radio-list-complex-base.component';
import { ShFormRadioListBaseComponent } from '../base-simple/form-radio-list-base.component';

@Component({
    selector: 'sh-form-radio-list',
    templateUrl: './form-radio-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        ShFormGroupComponent,
        NgIf,
        ShFormRadioListComplexBaseComponent,
        ReactiveFormsModule,
        ShFormRadioListBaseComponent,
        AsyncPipe
    ]
})
export class ShFormRadioListComponent extends ShBaseFormComponent {
    @Input() inline: boolean = false;
    @Input() groupName?: string;
    @Input() items!: FormRadioListItem[];
    @Input() clearable: boolean = false;

    protected override initLabelActions(): void {
        super.initLabelActions();

        this.labelActions$ = combineLatest([this.labelActions$, this.clearAction]).pipe(
            map(([actions, action]) => (action ? actions.concat(action) : actions))
        );
    }

    private get clearAction(): Observable<ActionItem | null> {
        return this.clearable
            ? this.control.valueChanges.pipe(
                  startWith(this.control.value),
                  map(
                      value => !value || value.every((formValue: FormValue) => formValue.state === FormValueState.UNSET)
                  ),
                  map(disabled => ({
                      label: this.translateService.translate('actions.clear'),
                      eventListener: () => this.control.setValue([new FormValue(null, FormValueState.UNSET)]),
                      style: ActionItemStyle.Link,
                      disabled: disabled || this.control.disabled
                  }))
              )
            : of(null);
    }
}
